// @flow
import React from 'react';
// Components
import { FreeShippingNotice } from '../../common';
import BigClubNotice from './BigClubNotice';
// Styles
import './CartPanel.css';
import PromotionNotice from './PromotionNotice';

type CartPanelProps = {
  numberOfItems: number,
  totalCartPrice: number,
  bigClubInfo?: BigClubInfo,
  minPriceToEarnCashback?: number,
  shouldDisplayFreeShippingNotice: boolean,
  shouldDisplayBigClubNotice?: boolean,
};

const CartPanel = ({
  numberOfItems,
  totalCartPrice,
  bigClubInfo,
  minPriceToEarnCashback,
  shouldDisplayFreeShippingNotice,
  shouldDisplayBigClubNotice,
  promotions,
}: CartPanelProps) => {
  return (
    <div className="cart-panel-container">
      <div className="cart-panel-header-container">
        <div className="cart-panel-cart-items-quantity">
          <div class="cart-indicator-button-icon" aria-label="Carrinho"></div>
          <h1>Carrinho ({numberOfItems})</h1>
        </div>
      </div>
      {shouldDisplayBigClubNotice && (
        <div className="cart-panel-cashback-container">
          <BigClubNotice
            totalCartPrice={totalCartPrice}
            bigClubInfo={bigClubInfo}
            minPriceToEarnCashback={minPriceToEarnCashback}
          />
        </div>
      )}
      {!!totalCartPrice && (
        <div className="cart-panel-freightage-container">
          <FreeShippingNotice currentPrice={totalCartPrice} />
        </div>
      )}
      {!!totalCartPrice &&
        promotions.map(promotion => {
          return promotion.viewOnCart ? (
            <div className="cart-panel-freightage-container">
              <PromotionNotice
                currentPrice={totalCartPrice}
                promotion={promotion}
              />
            </div>
          ) : null;
        })}
    </div>
  );
};

export default CartPanel;
